import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Paper,
  Typography,
} from '@mui/material'
import Page from '../layout/Page'
import { unsubscribe } from './data'
import { getSiteConfigRoutes, getSiteConfig } from '../community/siteProvider'

export default function CommunityForumPage(props = {}) {
  const [isLoading, setIsLoading] = useState(false)
  const [email, setEmail] = useState(null)
  const [selectedHubs, setSelectedHubs] = useState([])
  const [unsubscribeAll, setUnsubscribeAll] = useState(false)
  const [siteConfigs, setSiteConfigs] = useState([])

  const location = useLocation()
  const navigate = useNavigate()

  const startLoading = () => setIsLoading(true)
  const stopLoading = () => setIsLoading(false)

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search)
    const emailFromQuery = searchParams.get('email')
    setEmail(emailFromQuery)
    const _siteConfigs = getSiteConfigRoutes()
    setSiteConfigs(_siteConfigs)
    const _siteConfig = getSiteConfig()
    console.log(_siteConfig)
    setSelectedHubs([_siteConfig.siteId])
  }, [location.search])

  const handleHubToggle = (siteId) => {
    setSelectedHubs((prev) =>
      prev.includes(siteId)
        ? prev.filter((id) => id !== siteId)
        : [...prev, siteId]
    )
  }

  const handleUnsubscribeAllToggle = (checked) => {
    setUnsubscribeAll(checked)
    if (checked) {
      setSelectedHubs([])
    }
  }

  const handleSubmit = async () => {
    if (!email) return

    startLoading()

    if (unsubscribeAll) {
      await unsubscribe(email, siteConfigs)
    } else {
      await unsubscribe(email, siteConfigs.filter(sc => selectedHubs.includes(sc.siteId)))
    }

    stopLoading()

    const hub = window.location.pathname.split('/')[1]
    navigate(`/${hub}/news`, {
      state: { unsubscribed: true },
    })
  }

  const isSubmitDisabled =
    (!unsubscribeAll && selectedHubs.length === 0) || !email

  return (
    <Page {...props} isLoading={isLoading}>
      <Paper
        sx={{
          maxWidth: 500,
          margin: '0 auto',
          padding: 4,
          boxShadow: 'none',
          backgroundColor: 'transparent',
        }}
      >
        <Typography variant="h5" gutterBottom>
          Manage Email Preferences
        </Typography>

        <Typography variant="body2" sx={{ mb: 3 }}>
          Select the community hubs you’d like to stop receiving emails from.
        </Typography>

        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
          <FormControlLabel
            control={
              <Checkbox
                checked={unsubscribeAll}
                onChange={(e) =>
                  handleUnsubscribeAllToggle(e.target.checked)
                }
              />
            }
            label="Unsubscribe from all communities"
          />

          {!unsubscribeAll &&
            siteConfigs.map((hub) => (
              <FormControlLabel
                key={hub.id}
                control={
                  <Checkbox
                    checked={selectedHubs.includes(hub.siteId)}
                    onChange={() => handleHubToggle(hub.siteId)}
                  />
                }
                label={hub.label}
              />
            ))}
        </Box>

        <Button
          variant="contained"
          color="primary"
          sx={{ mt: 3 }}
          disabled={isSubmitDisabled}
          onClick={handleSubmit}
        >
          Confirm Unsubscribe
        </Button>
      </Paper>
    </Page>
  )
}